module.exports = __webpack_public_path__ + "img/caixa-registradora.f6082a7d.png";